import React from "react";
import { Col, Form, Radio, Row, Select } from "antd";

import { FInput, FSelect } from "../../common/form/index.js";
import { observer } from "mobx-react";

import { removeEmojis } from "../../utils/index";
let isImeOn = false; // IME 入力中フラグ

// 文字数制限を超えているか
let isNameTooLong = false;
const NameLimit = 10;

const Option = Select.Option;
const RadioGroup = Radio.Group;
const radioStyle = {
  display: "block",
  height: "30px",
  lineHeight: "30px"
};

let childType = ''; // 'daughter' | 'son' render() で this.props.book.artistName の値で更新
let bandImageId = '0'; // 推薦文画像のid 娘からと息子からで少しだけ差があるので、この変数で管理

/*
TODO: 娘からと息子からで、メディアからの推薦文の一部radiosの文字・順番などが異なる
息子から〜が追加される際は、band画像の一部追加が必要
*/
const sentences = {
  "1": {
    option: "あなたの兄弟姉妹からの推薦文",
    label: "あなたの兄弟姉妹のお名前をご記入ください。",
    radios: { // どちらも一緒
      daughter: [
        "育て方がお上手!!!",
        "抜け駆けズルい。",
        "親の顔が見てみたいわ。",
        "全オレが泣いた。。"
      ],
      son: [
        "育て方がお上手!!!",
        "抜け駆けズルい。",
        "親の顔が見てみたいわ。",
        "全オレが泣いた。。"
      ],
    }
  },
  "2": {
    option: "ペットからの推薦文",
    label: "ペットのお名前をご記入ください。",
    radios: { // どちらも一緒
      daughter: [
        "ワンッだふる!!",
        "ニャ〜べらす!!"
      ],
      son: [
        "ワンッだふる!!",
        "ニャ〜べらす!!"
      ],
    }
  },
  "3": {
    option: "メディアからの推薦文",
    label: "",
    radios: { // 微妙に異なる
      daughter: [
        "全米がどよめいた。",
        "あの「フラダンスの犬」を凌ぐ感動作!!!",
        "こんな娘が欲しかった!!",
        "バカデミー賞５部門ノミネート!!!",
        "今年最高の感動を。",
        "ハンカチの準備はできていますか？",
        "家族の愛は、永久に不滅です。",
        "誰もいないところで読んでください。",
        "届けたかった想いが、ここにある。",
        "忘れられない一冊に、きっとなる。",
        "世界で一番純粋なありがとう。"
      ],
      son: [
        "全米がどよめいた。",
        "あの迷作が待望の書籍化決定!!",
        "あの「フラダンスの犬」を凌ぐ感動作!!!",
        "あなたはこの衝撃についてこれるか。",
        "こんな息子が欲しかった!!",
        "衝撃のラストを見逃すな。",
        "バカデミー賞５部門ノミネート!!!",
        "今年最高の感動を。",
        "ハンカチの準備はできていますか？",
        "家族の愛は、永久に不滅です。",
        "届けたかった想いが、ここにある。",
      ],
    }
  }
};

const blurbTextToFirstSelectIndex = b =>
  b <= sentences["1"].radios[childType].length
    ? "1"
    : b <= sentences["1"].radios[childType].length + sentences["2"].radios[childType].length
      ? "2"
      : "3";

const blurbTextToSecondSelectIndex = b =>
  b <= sentences["1"].radios[childType].length
    ? b - 1
    : b <= sentences["1"].radios[childType].length + sentences["2"].radios[childType].length
      ? b - sentences["1"].radios[childType].length - 1
      : b - sentences["1"].radios[childType].length - sentences["2"].radios[childType].length - 1;

const getBlurbTextId = (sentenceId, radioId) => {
  let blurbTextId = 1;

  const nbRadioOne = sentences[1].radios[childType].length;
  const nbRadioTwo = sentences[2].radios[childType].length;

  if (sentenceId === "1") {
    blurbTextId += radioId;
  } else if (sentenceId === "2") {
    blurbTextId += nbRadioOne + radioId;
  } else if (sentenceId === "3") {
    blurbTextId += nbRadioOne + nbRadioTwo + radioId;
  }
  return blurbTextId;
};

class Panflet extends React.Component {
  state = {
    name: "",
    radioSelected: -1,
    saved: false,
    selected: undefined
  };

  // 推薦文画像ファイル名に使用
  setBandImageId = (selected, radioSelected) => {
    const id = getBlurbTextId(selected, radioSelected);
    // console.log('setBandImageId', selected, radioSelected, id);
    // 8以降はchildTypeを付与
    bandImageId = id <= 7
      ? id
      : `${id}_${childType}`;
  }

  handleSaving = () => {
    this.props.book.childToParent.changeBlurbName(this.state.name);
    this.props.book.childToParent.changeBlurbText(
      getBlurbTextId(this.state.selected, this.state.radioSelected)
    );
    this.props.order.nextStep();
    this.setState({ saved: true });
  };

  handleSelectChange = s => {
    isNameTooLong = false;
    this.setState({ name: "", radioSelected: 0, selected: s });
    this.setBandImageId(s, 0);
  };
  handleRadioChange = e => {
    const v = e.target.value;
    const s = this.state.selected;
    this.setState({ radioSelected: v, saved: false });
    this.setBandImageId(s, v);
  };
  handleTextChange = e => {
    // console.log('onChange', e.target.value);
    let name = e.target.value;
    if(!isImeOn) {
      name = removeEmojis(name); // 絵文字があれば除去
    }
    isNameTooLong = name.length > NameLimit;
    this.setState({ name, saved: false });
  }
  // 入力フォームの onChange イベントを IME ON のときに無視する
  // https://maku.blog/p/cv6fpx7/
  handleTextCompositionStart = () => {
    // console.log('handleTextCompositionStart');
    isImeOn = true; // IME 入力中フラグを ON
  }
  handleTextCompositionEnd = e => {
    // console.log('handleTextCompositionEnd');
    isImeOn = false; // IME 入力中フラグを OFF
    this.handleTextChange(e);
  }

  componentWillMount() {
    if (this.props.book) {
      // childTypeを指定
      childType = this.props.book.artistName === 'aoyama' ? 'daughter' : 'son';
      const { blurbName, blurbText } = this.props.book.childToParent;
      if (blurbName !== "") this.setState({ name: blurbName });
      if (blurbText !== 0) {
        const radioSelected = blurbTextToSecondSelectIndex(blurbText);
        const selected = blurbTextToFirstSelectIndex(blurbText);
        this.setState({
          radioSelected,
          selected
        });
        this.setBandImageId(selected, radioSelected);
      }
    }
  }

  render() {
    const values = sentences,
      s = this.state.selected,
      rs = this.state.radioSelected,
      current = values[this.state.selected],
      { book, setpImage } = this.props;

    return (
      <div className="panflet">
        <div className="pd-15">
          <img
            style={{ width: "100%" }}
            src={require(`../../imgs/${setpImage}`)}
          />
          <div className="step m-t25">
            <div className="step-title">{"STEP 1"}</div>
            <div className="step-txt">{"推薦人を選んでください。"}</div>
          </div>

          <Form layout="vertical">
            <Row>
              <Col span={24} className="first-choice">
                <FSelect
                  onChange={this.handleSelectChange}
                  placeholder="推薦人/推薦文の選択"
                  style={{ marginTop: "20px" }}
                  value={this.state.selected}
                  size="large"
                >
                  {Object.keys(values).map((k, idx) => (
                    <Option key={idx} value={k}>
                      {values[k].option}
                    </Option>
                  ))}
                </FSelect>
              </Col>
              {current
                ? [
                  <Col key={0} span={24} style={{ marginBottom: "20px" }}>
                    <div className="step m-t25">
                      <div className="step-title">{"STEP 2"}</div>
                      <div className="step-txt">
                        {"推薦文を選択してください。"}
                      </div>
                    </div>
                    <br />
                    <RadioGroup
                      onChange={this.handleRadioChange}
                      value={this.state.radioSelected}
                    >
                      {current.radios[childType].map((v, idx) => (
                        <Radio key={idx} style={radioStyle} value={idx}>
                          {v}
                        </Radio>
                      ))}
                    </RadioGroup>
                    <div key={1} />
                  </Col>,
                  this.state.selected !== "3" ? (
                    <div key={1}>
                      <div className="step m-t25">
                        <div className="step-title">{"STEP 3"}</div>
                        <div className="step-txt">
                          {"下記●●●●●●部分に入る推薦人のお名前（敬称含め10文字以内）を入力してください。"}
                        </div>
                      </div>
                      <br />
                      <div data-warning={isNameTooLong}>
                        <Col span={24}>
                          <FInput
                            onChange={this.handleTextChange}
                            onCompositionStart={this.handleTextCompositionStart}
                            onCompositionEnd={this.handleTextCompositionEnd}
                            size="large"
                            value={this.state.name}
                          />
                        </Col>
                      </div>
                    </div>
                  ) : (
                    <div key={1} />
                  ),
                  <Col
                    key={2}
                    span={24}
                    className="bandPreview"
                  >
                    <img
                      className="bandPreview_image"
                      src={require(`../../imgs/child_to_parent/band_${bandImageId}.png`)}
                      alt=""
                    />
                    <img
                      className="bandPreview_bg"
                      src={require(`../../imgs/child_to_parent/bg_panflet_${childType}.png`)}
                      alt=""
                    />
                    {this.state.selected !== "3"
                      ? [
                        <div key={3} className="bandPreview_text">
                          あの
                          {this.state.name.length
                          ? this.state.name
                          : "●●●●●●"}
                          が絶賛！
                        </div>
                      ]
                      : null}
                  </Col>
                ]
                : null}
            </Row>
          </Form>
        </div>
        <div className="pd-15">
          <div className="btn-wrap">
            <button
              onClick={this.handleSaving}
              className="btn product-btn"
              disabled={
                (this.state.name === "" && this.state.selected !== "3") ||
                this.state.radioSelected === -1 ||
                isNameTooLong
              }
            >
              保存して次へ
              <img
                src="https://cdn.shopify.com/s/files/1/0012/2568/7076/files/arrow-right-purple.png?13701503969354364487"
                className="btn-arrow"
              />
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default observer(Panflet);



// WEBPACK FOOTER //
// ./src/components/steps/PanfletChildToParent.js